import src from "IMAGE";
export default { src, width: 5069, height: 849, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAIUlEQVR42mM4sO5L88db9wP////vC8T+QBwFxCC+HYgGAKYyGaXVQWSzAAAAAElFTkSuQmCC"};
